/**
 * This file was auto-generated by @openapi-qraft/cli.
 * Do not make direct changes to the file.
 */

import type {
  DeepReadonly,
  InvalidateQueryFilters,
  MutationFiltersByMutationKey,
  MutationFiltersByParameters,
  MutationVariables,
  OperationError,
  OperationInfiniteData,
  PartialParameters,
  QraftServiceOperationsToken,
  QueryFiltersByParameters,
  QueryFiltersByQueryKey,
  QueryFnOptionsByParameters,
  QueryFnOptionsByQueryKey,
  RequestFnResponse,
  ServiceOperationEnsureInfiniteQueryDataOptions,
  ServiceOperationEnsureQueryDataOptions,
  ServiceOperationFetchInfiniteQueryOptions,
  ServiceOperationFetchQueryOptions,
  ServiceOperationInfiniteQueryKey,
  ServiceOperationMutationFnOptions,
  ServiceOperationMutationKey,
  ServiceOperationQueryKey,
  ServiceOperationUseMutationOptions,
  UseQueryOptionsForUseQueries,
  UseQueryOptionsForUseSuspenseQuery,
  WithOptional,
} from '@openapi-qraft/tanstack-query-react-types';
import type {
  CancelOptions,
  DefinedInitialDataInfiniteOptions,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteQueryPageParamsOptions,
  InvalidateOptions,
  Mutation,
  MutationCache,
  MutationState,
  NoInfer,
  QueryState,
  RefetchOptions,
  ResetOptions,
  SetDataOptions,
  UndefinedInitialDataInfiniteOptions,
  UndefinedInitialDataOptions,
  Updater,
  UseInfiniteQueryResult,
  UseMutationResult,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';

import type { paths } from '../schema';

export interface NotificationTriggersService {
  /**
   * @summary Get All
   * @description Get all notification triggers for the current office, including system triggers.
   */
  getAllNotificationTriggersGet: {
    /**
     * @summary Get All
     * @description Get all notification triggers for the current office, including system triggers.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<
            GetAllNotificationTriggersGetSchema,
            GetAllNotificationTriggersGetParameters,
            TMeta,
            TSignal
          >
        | (QueryFnOptionsByParameters<GetAllNotificationTriggersGetParameters, TMeta, TSignal> | void),
      client?: (
        schema: GetAllNotificationTriggersGetSchema,
        options: {
          parameters: GetAllNotificationTriggersGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<GetAllNotificationTriggersGetData, GetAllNotificationTriggersGetError>>
    ): Promise<RequestFnResponse<GetAllNotificationTriggersGetData, GetAllNotificationTriggersGetError>>;
    /**
     * @summary Get All
     * @description Get all notification triggers for the current office, including system triggers.
     */
    getQueryKey(
      parameters: DeepReadonly<GetAllNotificationTriggersGetParameters> | void
    ): ServiceOperationQueryKey<GetAllNotificationTriggersGetSchema, GetAllNotificationTriggersGetParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get All
     * @description Get all notification triggers for the current office, including system triggers.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.notificationTriggersService.getAllNotificationTriggersGet.useQuery()
     * ```
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.notificationTriggersService.getAllNotificationTriggersGet.useQuery({
     *     query: {
     *         skip: skip
     *     }
     * })
     * ```
     */
    useQuery<TData = GetAllNotificationTriggersGetData>(
      parameters:
        | ServiceOperationQueryKey<GetAllNotificationTriggersGetSchema, GetAllNotificationTriggersGetParameters>
        | (DeepReadonly<GetAllNotificationTriggersGetParameters> | void),
      options?: Omit<
        UndefinedInitialDataOptions<
          GetAllNotificationTriggersGetData,
          GetAllNotificationTriggersGetError,
          TData,
          ServiceOperationQueryKey<GetAllNotificationTriggersGetSchema, GetAllNotificationTriggersGetParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<GetAllNotificationTriggersGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get All
     * @description Get all notification triggers for the current office, including system triggers.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.notificationTriggersService.getAllNotificationTriggersGet.useQuery()
     * ```
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.notificationTriggersService.getAllNotificationTriggersGet.useQuery({
     *     query: {
     *         skip: skip
     *     }
     * })
     * ```
     */
    useQuery<TData = GetAllNotificationTriggersGetData>(
      parameters:
        | ServiceOperationQueryKey<GetAllNotificationTriggersGetSchema, GetAllNotificationTriggersGetParameters>
        | (DeepReadonly<GetAllNotificationTriggersGetParameters> | void),
      options: Omit<
        DefinedInitialDataOptions<
          GetAllNotificationTriggersGetData,
          GetAllNotificationTriggersGetError,
          TData,
          ServiceOperationQueryKey<GetAllNotificationTriggersGetSchema, GetAllNotificationTriggersGetParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<GetAllNotificationTriggersGetError>>;
    /**
     * @summary Get All
     * @description Get all notification triggers for the current office, including system triggers.
     */
    getInfiniteQueryKey(
      parameters: DeepReadonly<GetAllNotificationTriggersGetParameters> | void
    ): ServiceOperationInfiniteQueryKey<GetAllNotificationTriggersGetSchema, GetAllNotificationTriggersGetParameters>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get All
     * @description Get all notification triggers for the current office, including system triggers.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.notificationTriggersService.getAllNotificationTriggersGet.useInfiniteQuery({}, {
     *     initialPageParam: {
     *         query: {
     *             skip: initialSkip
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetAllNotificationTriggersGetParameters,
      TQueryFnData = GetAllNotificationTriggersGetData,
      TData = OperationInfiniteData<TQueryFnData, GetAllNotificationTriggersGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetAllNotificationTriggersGetSchema, GetAllNotificationTriggersGetParameters>
        | (DeepReadonly<GetAllNotificationTriggersGetParameters> | void),
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetAllNotificationTriggersGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            GetAllNotificationTriggersGetSchema,
            GetAllNotificationTriggersGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<GetAllNotificationTriggersGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get All
     * @description Get all notification triggers for the current office, including system triggers.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.notificationTriggersService.getAllNotificationTriggersGet.useInfiniteQuery({}, {
     *     initialPageParam: {
     *         query: {
     *             skip: initialSkip
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetAllNotificationTriggersGetParameters,
      TQueryFnData = GetAllNotificationTriggersGetData,
      TData = OperationInfiniteData<TQueryFnData, GetAllNotificationTriggersGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetAllNotificationTriggersGetSchema, GetAllNotificationTriggersGetParameters>
        | (DeepReadonly<GetAllNotificationTriggersGetParameters> | void),
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetAllNotificationTriggersGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            GetAllNotificationTriggersGetSchema,
            GetAllNotificationTriggersGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<GetAllNotificationTriggersGetData, PartialParameters<DeepReadonly<TPageParam>>>
    ): DefinedUseInfiniteQueryResult<TData, OperationError<GetAllNotificationTriggersGetError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Get All
     * @description Get all notification triggers for the current office, including system triggers.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const getAllNotificationTriggersGetTotal = qraft.notificationTriggersService.getAllNotificationTriggersGet.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const getAllNotificationTriggersGetByParametersTotal = qraft.notificationTriggersService.getAllNotificationTriggersGet.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         query: {
     *             skip: skip
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllNotificationTriggersGetSchema,
            GetAllNotificationTriggersGetData,
            TInfinite,
            GetAllNotificationTriggersGetParameters,
            GetAllNotificationTriggersGetError
          >
        | QueryFiltersByQueryKey<
            GetAllNotificationTriggersGetSchema,
            GetAllNotificationTriggersGetData,
            TInfinite,
            GetAllNotificationTriggersGetParameters,
            GetAllNotificationTriggersGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Get All
     * @description Get all notification triggers for the current office, including system triggers.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const getAllNotificationTriggersGetResults = qraft.notificationTriggersService.getAllNotificationTriggersGet.useQueries({
     *     queries: [
     *         {
     *             query: {
     *                 skip: skip1
     *             }
     *         },
     *         {
     *             query: {
     *                 skip: skip2
     *             }
     *         }
     *     ]
     * });
     * getAllNotificationTriggersGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const getAllNotificationTriggersGetCombinedResults = qraft.notificationTriggersService.getAllNotificationTriggersGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             query: {
     *                 skip: skip1
     *             }
     *         },
     *         {
     *             query: {
     *                 skip: skip2
     *             }
     *         }
     *     ]
     * });
     * getAllNotificationTriggersGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          GetAllNotificationTriggersGetSchema,
          GetAllNotificationTriggersGetParameters,
          GetAllNotificationTriggersGetData,
          GetAllNotificationTriggersGetError
        >
      >,
      TCombinedResult = Array<UseQueryResult<GetAllNotificationTriggersGetData, GetAllNotificationTriggersGetError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<UseQueryResult<GetAllNotificationTriggersGetData, GetAllNotificationTriggersGetError>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Get All
     * @description Get all notification triggers for the current office, including system triggers.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query without parameters
     * ```ts
     * const data = qraft.notificationTriggersService.getAllNotificationTriggersGet.useSuspenseQuery()
     * ```
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.notificationTriggersService.getAllNotificationTriggersGet.useSuspenseQuery({
     *     query: {
     *         skip: skip
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = GetAllNotificationTriggersGetData>(
      parameters:
        | ServiceOperationQueryKey<GetAllNotificationTriggersGetSchema, GetAllNotificationTriggersGetParameters>
        | (DeepReadonly<GetAllNotificationTriggersGetParameters> | void),
      options?: Omit<
        UseSuspenseQueryOptions<
          GetAllNotificationTriggersGetData,
          GetAllNotificationTriggersGetError,
          TData,
          ServiceOperationQueryKey<GetAllNotificationTriggersGetSchema, GetAllNotificationTriggersGetParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<GetAllNotificationTriggersGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Get All
     * @description Get all notification triggers for the current office, including system triggers.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.notificationTriggersService.getAllNotificationTriggersGet.useSuspenseInfiniteQuery({}, {
     *     initialPageParam: {
     *         query: {
     *             skip: initialSkip
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<
      TPageParam extends GetAllNotificationTriggersGetParameters,
      TData = GetAllNotificationTriggersGetData,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetAllNotificationTriggersGetSchema, GetAllNotificationTriggersGetParameters>
        | (DeepReadonly<GetAllNotificationTriggersGetParameters> | void),
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          GetAllNotificationTriggersGetData,
          GetAllNotificationTriggersGetError,
          OperationInfiniteData<TData, GetAllNotificationTriggersGetParameters>,
          ServiceOperationInfiniteQueryKey<
            GetAllNotificationTriggersGetSchema,
            GetAllNotificationTriggersGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<GetAllNotificationTriggersGetData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, GetAllNotificationTriggersGetParameters>,
      OperationError<GetAllNotificationTriggersGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Get All
     * @description Get all notification triggers for the current office, including system triggers.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const getAllNotificationTriggersGetData = qraft.notificationTriggersService.getAllNotificationTriggersGet.useSuspenseQueries({
     *     queries: [
     *         {
     *             query: {
     *                 skip: skip1
     *             }
     *         },
     *         {
     *             query: {
     *                 skip: skip2
     *             }
     *         }
     *     ]
     * });
     * getAllNotificationTriggersGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const getAllNotificationTriggersGetCombinedData = qraft.notificationTriggersService.getAllNotificationTriggersGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             query: {
     *                 skip: skip1
     *             }
     *         },
     *         {
     *             query: {
     *                 skip: skip2
     *             }
     *         }
     *     ]
     * });
     * getAllNotificationTriggersGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          GetAllNotificationTriggersGetSchema,
          GetAllNotificationTriggersGetParameters,
          GetAllNotificationTriggersGetData,
          GetAllNotificationTriggersGetError
        >
      >,
      TCombinedResult = Array<
        UseSuspenseQueryResult<GetAllNotificationTriggersGetData, GetAllNotificationTriggersGetError>
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<
            UseSuspenseQueryResult<GetAllNotificationTriggersGetData, GetAllNotificationTriggersGetError>,
            'data'
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * @summary Get All
     * @description Get all notification triggers for the current office, including system triggers.
     */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetAllNotificationTriggersGetSchema,
        GetAllNotificationTriggersGetData,
        GetAllNotificationTriggersGetParameters,
        GetAllNotificationTriggersGetError
      > | void
    ): Promise<GetAllNotificationTriggersGetData>;
    /**
     * @summary Get All
     * @description Get all notification triggers for the current office, including system triggers.
     */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetAllNotificationTriggersGetSchema,
        GetAllNotificationTriggersGetData,
        GetAllNotificationTriggersGetParameters,
        GetAllNotificationTriggersGetError
      > | void
    ): Promise<void>;
    /**
     * @summary Get All
     * @description Get all notification triggers for the current office, including system triggers.
     */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        GetAllNotificationTriggersGetSchema,
        GetAllNotificationTriggersGetData,
        GetAllNotificationTriggersGetParameters,
        GetAllNotificationTriggersGetError
      > | void
    ): Promise<GetAllNotificationTriggersGetData>;
    /**
     * @summary Get All
     * @description Get all notification triggers for the current office, including system triggers.
     */
    fetchInfiniteQuery<TPageParam extends GetAllNotificationTriggersGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetAllNotificationTriggersGetSchema,
        GetAllNotificationTriggersGetData,
        GetAllNotificationTriggersGetParameters,
        DeepReadonly<TPageParam>,
        GetAllNotificationTriggersGetError
      > | void
    ): Promise<OperationInfiniteData<GetAllNotificationTriggersGetData, GetAllNotificationTriggersGetParameters>>;
    /**
     * @summary Get All
     * @description Get all notification triggers for the current office, including system triggers.
     */
    prefetchInfiniteQuery<TPageParam extends GetAllNotificationTriggersGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetAllNotificationTriggersGetSchema,
        GetAllNotificationTriggersGetData,
        GetAllNotificationTriggersGetParameters,
        DeepReadonly<TPageParam>,
        GetAllNotificationTriggersGetError
      > | void
    ): Promise<void>;
    /**
     * @summary Get All
     * @description Get all notification triggers for the current office, including system triggers.
     */
    ensureInfiniteQueryData<TPageParam extends GetAllNotificationTriggersGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        GetAllNotificationTriggersGetSchema,
        GetAllNotificationTriggersGetData,
        GetAllNotificationTriggersGetParameters,
        DeepReadonly<TPageParam>,
        GetAllNotificationTriggersGetError
      > | void
    ): Promise<OperationInfiniteData<GetAllNotificationTriggersGetData, GetAllNotificationTriggersGetParameters>>;
    /**
     * @summary Get All
     * @description Get all notification triggers for the current office, including system triggers.
     */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<GetAllNotificationTriggersGetSchema, GetAllNotificationTriggersGetParameters>
        | (DeepReadonly<GetAllNotificationTriggersGetParameters> | void)
    ): GetAllNotificationTriggersGetData | undefined;
    /**
     * @summary Get All
     * @description Get all notification triggers for the current office, including system triggers.
     */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetAllNotificationTriggersGetSchema, GetAllNotificationTriggersGetParameters>
        | (DeepReadonly<GetAllNotificationTriggersGetParameters> | void)
    ): OperationInfiniteData<GetAllNotificationTriggersGetData, GetAllNotificationTriggersGetParameters> | undefined;
    /**
     * @summary Get All
     * @description Get all notification triggers for the current office, including system triggers.
     */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllNotificationTriggersGetSchema,
            GetAllNotificationTriggersGetData,
            TInfinite,
            GetAllNotificationTriggersGetParameters,
            GetAllNotificationTriggersGetError
          >
        | QueryFiltersByQueryKey<
            GetAllNotificationTriggersGetSchema,
            GetAllNotificationTriggersGetData,
            TInfinite,
            GetAllNotificationTriggersGetParameters,
            GetAllNotificationTriggersGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<
              GetAllNotificationTriggersGetSchema,
              GetAllNotificationTriggersGetParameters
            >,
            data:
              | NoInfer<
                  OperationInfiniteData<GetAllNotificationTriggersGetData, GetAllNotificationTriggersGetParameters>
                >
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<
              GetAllNotificationTriggersGetSchema,
              GetAllNotificationTriggersGetParameters
            >,
            data: GetAllNotificationTriggersGetData | undefined,
          ]
        >;
    /**
     * @summary Get All
     * @description Get all notification triggers for the current office, including system triggers.
     */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<GetAllNotificationTriggersGetSchema, GetAllNotificationTriggersGetParameters>
        | (DeepReadonly<GetAllNotificationTriggersGetParameters> | void)
    ): QueryState<GetAllNotificationTriggersGetData, GetAllNotificationTriggersGetError> | undefined;
    /**
     * @summary Get All
     * @description Get all notification triggers for the current office, including system triggers.
     */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<GetAllNotificationTriggersGetParameters>
        | ServiceOperationInfiniteQueryKey<GetAllNotificationTriggersGetSchema, GetAllNotificationTriggersGetParameters>
        | void
    ):
      | QueryState<
          OperationInfiniteData<GetAllNotificationTriggersGetData, GetAllNotificationTriggersGetParameters>,
          GetAllNotificationTriggersGetError
        >
      | undefined;
    /**
     * @summary Get All
     * @description Get all notification triggers for the current office, including system triggers.
     */
    setQueryData(
      parameters:
        | (DeepReadonly<GetAllNotificationTriggersGetParameters> | undefined)
        | ServiceOperationQueryKey<GetAllNotificationTriggersGetSchema, GetAllNotificationTriggersGetParameters>,
      updater: Updater<
        NoInfer<GetAllNotificationTriggersGetData> | undefined,
        NoInfer<DeepReadonly<GetAllNotificationTriggersGetData>> | undefined
      >,
      options?: SetDataOptions
    ): GetAllNotificationTriggersGetData | undefined;
    /**
     * @summary Get All
     * @description Get all notification triggers for the current office, including system triggers.
     */
    setInfiniteQueryData(
      parameters:
        | (DeepReadonly<GetAllNotificationTriggersGetParameters> | undefined)
        | ServiceOperationInfiniteQueryKey<
            GetAllNotificationTriggersGetSchema,
            GetAllNotificationTriggersGetParameters
          >,
      updater: Updater<
        | NoInfer<OperationInfiniteData<GetAllNotificationTriggersGetData, GetAllNotificationTriggersGetParameters>>
        | undefined,
        | NoInfer<
            DeepReadonly<
              OperationInfiniteData<GetAllNotificationTriggersGetData, GetAllNotificationTriggersGetParameters>
            >
          >
        | undefined
      >,
      options?: SetDataOptions
    ): OperationInfiniteData<GetAllNotificationTriggersGetData, GetAllNotificationTriggersGetParameters> | undefined;
    /**
     * @summary Get All
     * @description Get all notification triggers for the current office, including system triggers.
     */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            GetAllNotificationTriggersGetSchema,
            GetAllNotificationTriggersGetData,
            TInfinite,
            GetAllNotificationTriggersGetParameters,
            GetAllNotificationTriggersGetError
          >
        | QueryFiltersByQueryKey<
            GetAllNotificationTriggersGetSchema,
            GetAllNotificationTriggersGetData,
            TInfinite,
            GetAllNotificationTriggersGetParameters,
            GetAllNotificationTriggersGetError
          >,
      updater: Updater<
        NoInfer<GetAllNotificationTriggersGetData> | undefined,
        NoInfer<GetAllNotificationTriggersGetData> | undefined
      >,
      options?: SetDataOptions
    ): Array<GetAllNotificationTriggersGetData | undefined>;
    /**
     * @summary Get All
     * @description Get all notification triggers for the current office, including system triggers.
     */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        GetAllNotificationTriggersGetSchema,
        GetAllNotificationTriggersGetData,
        TInfinite,
        GetAllNotificationTriggersGetParameters,
        GetAllNotificationTriggersGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /**
     * @summary Get All
     * @description Get all notification triggers for the current office, including system triggers.
     */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllNotificationTriggersGetSchema,
            GetAllNotificationTriggersGetData,
            TInfinite,
            GetAllNotificationTriggersGetParameters,
            GetAllNotificationTriggersGetError
          >
        | QueryFiltersByQueryKey<
            GetAllNotificationTriggersGetSchema,
            GetAllNotificationTriggersGetData,
            TInfinite,
            GetAllNotificationTriggersGetParameters,
            GetAllNotificationTriggersGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /**
     * @summary Get All
     * @description Get all notification triggers for the current office, including system triggers.
     */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllNotificationTriggersGetSchema,
            GetAllNotificationTriggersGetData,
            TInfinite,
            GetAllNotificationTriggersGetParameters,
            GetAllNotificationTriggersGetError
          >
        | QueryFiltersByQueryKey<
            GetAllNotificationTriggersGetSchema,
            GetAllNotificationTriggersGetData,
            TInfinite,
            GetAllNotificationTriggersGetParameters,
            GetAllNotificationTriggersGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /**
     * @summary Get All
     * @description Get all notification triggers for the current office, including system triggers.
     */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllNotificationTriggersGetSchema,
            GetAllNotificationTriggersGetData,
            TInfinite,
            GetAllNotificationTriggersGetParameters,
            GetAllNotificationTriggersGetError
          >
        | QueryFiltersByQueryKey<
            GetAllNotificationTriggersGetSchema,
            GetAllNotificationTriggersGetData,
            TInfinite,
            GetAllNotificationTriggersGetParameters,
            GetAllNotificationTriggersGetError
          >
    ): void;
    /**
     * @summary Get All
     * @description Get all notification triggers for the current office, including system triggers.
     */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllNotificationTriggersGetSchema,
            GetAllNotificationTriggersGetData,
            TInfinite,
            GetAllNotificationTriggersGetParameters,
            GetAllNotificationTriggersGetError
          >
        | QueryFiltersByQueryKey<
            GetAllNotificationTriggersGetSchema,
            GetAllNotificationTriggersGetData,
            TInfinite,
            GetAllNotificationTriggersGetParameters,
            GetAllNotificationTriggersGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /**
     * @summary Get All
     * @description Get all notification triggers for the current office, including system triggers.
     */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllNotificationTriggersGetSchema,
            GetAllNotificationTriggersGetData,
            TInfinite,
            GetAllNotificationTriggersGetParameters,
            GetAllNotificationTriggersGetError
          >
        | QueryFiltersByQueryKey<
            GetAllNotificationTriggersGetSchema,
            GetAllNotificationTriggersGetData,
            TInfinite,
            GetAllNotificationTriggersGetParameters,
            GetAllNotificationTriggersGetError
          >
    ): number;
    schema: GetAllNotificationTriggersGetSchema;
    types: {
      parameters: GetAllNotificationTriggersGetParameters;
      data: GetAllNotificationTriggersGetData;
      error: GetAllNotificationTriggersGetError;
    };
  };
  /**
   * @summary Create
   * @description Create a new notification trigger.
   */
  createNotificationTriggersPost: {
    /**
     * @summary Create
     * @description Create a new notification trigger.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        CreateNotificationTriggersPostBody,
        CreateNotificationTriggersPostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: CreateNotificationTriggersPostSchema,
        options: ServiceOperationMutationFnOptions<
          CreateNotificationTriggersPostBody,
          CreateNotificationTriggersPostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<RequestFnResponse<CreateNotificationTriggersPostData, CreateNotificationTriggersPostError>>
    ): Promise<RequestFnResponse<CreateNotificationTriggersPostData, CreateNotificationTriggersPostError>>;
    /**
     * @summary Create
     * @description Create a new notification trigger.
     */
    getMutationKey(
      parameters: DeepReadonly<CreateNotificationTriggersPostParameters> | void
    ): ServiceOperationMutationKey<CreateNotificationTriggersPostSchema, CreateNotificationTriggersPostParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create
     * @description Create a new notification trigger.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.notificationTriggersService.createNotificationTriggersPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.notificationTriggersService.createNotificationTriggersPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends CreateNotificationTriggersPostBody, TContext = unknown>(
      parameters: DeepReadonly<CreateNotificationTriggersPostParameters>,
      options?: ServiceOperationUseMutationOptions<
        CreateNotificationTriggersPostSchema,
        CreateNotificationTriggersPostData,
        CreateNotificationTriggersPostParameters,
        TVariables,
        OperationError<CreateNotificationTriggersPostError>,
        TContext
      >
    ): UseMutationResult<
      CreateNotificationTriggersPostData,
      OperationError<CreateNotificationTriggersPostError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create
     * @description Create a new notification trigger.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.notificationTriggersService.createNotificationTriggersPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.notificationTriggersService.createNotificationTriggersPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        CreateNotificationTriggersPostBody,
        CreateNotificationTriggersPostParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        CreateNotificationTriggersPostSchema,
        CreateNotificationTriggersPostData,
        CreateNotificationTriggersPostParameters,
        TVariables,
        OperationError<CreateNotificationTriggersPostError>,
        TContext
      >
    ): UseMutationResult<
      CreateNotificationTriggersPostData,
      OperationError<CreateNotificationTriggersPostError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Create
     * @description Create a new notification trigger.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const createNotificationTriggersPostTotal = qraft.notificationTriggersService.createNotificationTriggersPost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const createNotificationTriggersPostTotal = qraft.notificationTriggersService.createNotificationTriggersPost.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            CreateNotificationTriggersPostBody,
            CreateNotificationTriggersPostData,
            CreateNotificationTriggersPostParameters,
            OperationError<CreateNotificationTriggersPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateNotificationTriggersPostSchema,
            CreateNotificationTriggersPostBody,
            CreateNotificationTriggersPostData,
            CreateNotificationTriggersPostParameters,
            OperationError<CreateNotificationTriggersPostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Create
     * @description Create a new notification trigger.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const createNotificationTriggersPostPendingMutationVariables = qraft.notificationTriggersService.createNotificationTriggersPost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const createNotificationTriggersPostMutationData = qraft.notificationTriggersService.createNotificationTriggersPost.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        CreateNotificationTriggersPostData,
        OperationError<CreateNotificationTriggersPostError>,
        MutationVariables<CreateNotificationTriggersPostBody, CreateNotificationTriggersPostParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            CreateNotificationTriggersPostBody,
            CreateNotificationTriggersPostData,
            CreateNotificationTriggersPostParameters,
            OperationError<CreateNotificationTriggersPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateNotificationTriggersPostSchema,
            CreateNotificationTriggersPostBody,
            CreateNotificationTriggersPostData,
            CreateNotificationTriggersPostParameters,
            OperationError<CreateNotificationTriggersPostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          CreateNotificationTriggersPostData,
          OperationError<CreateNotificationTriggersPostError>,
          MutationVariables<CreateNotificationTriggersPostBody, CreateNotificationTriggersPostParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Create
     * @description Create a new notification trigger.
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            CreateNotificationTriggersPostBody,
            CreateNotificationTriggersPostData,
            CreateNotificationTriggersPostParameters,
            OperationError<CreateNotificationTriggersPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateNotificationTriggersPostSchema,
            CreateNotificationTriggersPostBody,
            CreateNotificationTriggersPostData,
            CreateNotificationTriggersPostParameters,
            OperationError<CreateNotificationTriggersPostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Create
     * @description Create a new notification trigger.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.notificationTriggersService.createNotificationTriggersPost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.notificationTriggersService.createNotificationTriggersPost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              CreateNotificationTriggersPostBody,
              CreateNotificationTriggersPostData,
              CreateNotificationTriggersPostParameters,
              OperationError<CreateNotificationTriggersPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CreateNotificationTriggersPostSchema,
              CreateNotificationTriggersPostBody,
              CreateNotificationTriggersPostData,
              CreateNotificationTriggersPostParameters,
              OperationError<CreateNotificationTriggersPostError>,
              TContext
            >
      ):
        | Mutation<
            CreateNotificationTriggersPostData,
            CreateNotificationTriggersPostError,
            MutationVariables<CreateNotificationTriggersPostBody, CreateNotificationTriggersPostParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              CreateNotificationTriggersPostBody,
              CreateNotificationTriggersPostData,
              CreateNotificationTriggersPostParameters,
              OperationError<CreateNotificationTriggersPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CreateNotificationTriggersPostSchema,
              CreateNotificationTriggersPostBody,
              CreateNotificationTriggersPostData,
              CreateNotificationTriggersPostParameters,
              OperationError<CreateNotificationTriggersPostError>,
              TContext
            >
      ): Array<
        Mutation<
          CreateNotificationTriggersPostData,
          CreateNotificationTriggersPostError,
          MutationVariables<CreateNotificationTriggersPostBody, CreateNotificationTriggersPostParameters>,
          TContext
        >
      >;
    };
    schema: CreateNotificationTriggersPostSchema;
    types: {
      parameters: CreateNotificationTriggersPostParameters;
      data: CreateNotificationTriggersPostData;
      error: CreateNotificationTriggersPostError;
      body: CreateNotificationTriggersPostBody;
    };
  };
  /**
   * @summary Get By Id
   * @description Get notification trigger by ID.
   */
  getByIdNotificationTriggersTriggerIdGet: {
    /**
     * @summary Get By Id
     * @description Get notification trigger by ID.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<
            GetByIdNotificationTriggersTriggerIdGetSchema,
            GetByIdNotificationTriggersTriggerIdGetParameters,
            TMeta,
            TSignal
          >
        | QueryFnOptionsByParameters<GetByIdNotificationTriggersTriggerIdGetParameters, TMeta, TSignal>,
      client?: (
        schema: GetByIdNotificationTriggersTriggerIdGetSchema,
        options: {
          parameters: GetByIdNotificationTriggersTriggerIdGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<
        RequestFnResponse<GetByIdNotificationTriggersTriggerIdGetData, GetByIdNotificationTriggersTriggerIdGetError>
      >
    ): Promise<
      RequestFnResponse<GetByIdNotificationTriggersTriggerIdGetData, GetByIdNotificationTriggersTriggerIdGetError>
    >;
    /**
     * @summary Get By Id
     * @description Get notification trigger by ID.
     */
    getQueryKey(
      parameters: DeepReadonly<GetByIdNotificationTriggersTriggerIdGetParameters>
    ): ServiceOperationQueryKey<
      GetByIdNotificationTriggersTriggerIdGetSchema,
      GetByIdNotificationTriggersTriggerIdGetParameters
    >;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get By Id
     * @description Get notification trigger by ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.notificationTriggersService.getByIdNotificationTriggersTriggerIdGet.useQuery({
     *     path: {
     *         trigger_id: triggerId
     *     }
     * })
     * ```
     */
    useQuery<TData = GetByIdNotificationTriggersTriggerIdGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetByIdNotificationTriggersTriggerIdGetSchema,
            GetByIdNotificationTriggersTriggerIdGetParameters
          >
        | DeepReadonly<GetByIdNotificationTriggersTriggerIdGetParameters>,
      options?: Omit<
        UndefinedInitialDataOptions<
          GetByIdNotificationTriggersTriggerIdGetData,
          GetByIdNotificationTriggersTriggerIdGetError,
          TData,
          ServiceOperationQueryKey<
            GetByIdNotificationTriggersTriggerIdGetSchema,
            GetByIdNotificationTriggersTriggerIdGetParameters
          >
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<GetByIdNotificationTriggersTriggerIdGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get By Id
     * @description Get notification trigger by ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.notificationTriggersService.getByIdNotificationTriggersTriggerIdGet.useQuery({
     *     path: {
     *         trigger_id: triggerId
     *     }
     * })
     * ```
     */
    useQuery<TData = GetByIdNotificationTriggersTriggerIdGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetByIdNotificationTriggersTriggerIdGetSchema,
            GetByIdNotificationTriggersTriggerIdGetParameters
          >
        | DeepReadonly<GetByIdNotificationTriggersTriggerIdGetParameters>,
      options: Omit<
        DefinedInitialDataOptions<
          GetByIdNotificationTriggersTriggerIdGetData,
          GetByIdNotificationTriggersTriggerIdGetError,
          TData,
          ServiceOperationQueryKey<
            GetByIdNotificationTriggersTriggerIdGetSchema,
            GetByIdNotificationTriggersTriggerIdGetParameters
          >
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<GetByIdNotificationTriggersTriggerIdGetError>>;
    /**
     * @summary Get By Id
     * @description Get notification trigger by ID.
     */
    getInfiniteQueryKey(
      parameters: DeepReadonly<GetByIdNotificationTriggersTriggerIdGetParameters>
    ): ServiceOperationInfiniteQueryKey<
      GetByIdNotificationTriggersTriggerIdGetSchema,
      GetByIdNotificationTriggersTriggerIdGetParameters
    >;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get By Id
     * @description Get notification trigger by ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.notificationTriggersService.getByIdNotificationTriggersTriggerIdGet.useInfiniteQuery({
     *     path: {
     *         trigger_id: triggerId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetByIdNotificationTriggersTriggerIdGetParameters,
      TQueryFnData = GetByIdNotificationTriggersTriggerIdGetData,
      TData = OperationInfiniteData<TQueryFnData, GetByIdNotificationTriggersTriggerIdGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetByIdNotificationTriggersTriggerIdGetSchema,
            GetByIdNotificationTriggersTriggerIdGetParameters
          >
        | DeepReadonly<GetByIdNotificationTriggersTriggerIdGetParameters>,
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetByIdNotificationTriggersTriggerIdGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            GetByIdNotificationTriggersTriggerIdGetSchema,
            GetByIdNotificationTriggersTriggerIdGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<GetByIdNotificationTriggersTriggerIdGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get By Id
     * @description Get notification trigger by ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.notificationTriggersService.getByIdNotificationTriggersTriggerIdGet.useInfiniteQuery({
     *     path: {
     *         trigger_id: triggerId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetByIdNotificationTriggersTriggerIdGetParameters,
      TQueryFnData = GetByIdNotificationTriggersTriggerIdGetData,
      TData = OperationInfiniteData<TQueryFnData, GetByIdNotificationTriggersTriggerIdGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetByIdNotificationTriggersTriggerIdGetSchema,
            GetByIdNotificationTriggersTriggerIdGetParameters
          >
        | DeepReadonly<GetByIdNotificationTriggersTriggerIdGetParameters>,
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetByIdNotificationTriggersTriggerIdGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            GetByIdNotificationTriggersTriggerIdGetSchema,
            GetByIdNotificationTriggersTriggerIdGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          GetByIdNotificationTriggersTriggerIdGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): DefinedUseInfiniteQueryResult<TData, OperationError<GetByIdNotificationTriggersTriggerIdGetError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Get By Id
     * @description Get notification trigger by ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const getByIdNotificationTriggersTriggerIdGetTotal = qraft.notificationTriggersService.getByIdNotificationTriggersTriggerIdGet.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const getByIdNotificationTriggersTriggerIdGetByParametersTotal = qraft.notificationTriggersService.getByIdNotificationTriggersTriggerIdGet.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         path: {
     *             trigger_id: triggerId
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetByIdNotificationTriggersTriggerIdGetSchema,
            GetByIdNotificationTriggersTriggerIdGetData,
            TInfinite,
            GetByIdNotificationTriggersTriggerIdGetParameters,
            GetByIdNotificationTriggersTriggerIdGetError
          >
        | QueryFiltersByQueryKey<
            GetByIdNotificationTriggersTriggerIdGetSchema,
            GetByIdNotificationTriggersTriggerIdGetData,
            TInfinite,
            GetByIdNotificationTriggersTriggerIdGetParameters,
            GetByIdNotificationTriggersTriggerIdGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Get By Id
     * @description Get notification trigger by ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const getByIdNotificationTriggersTriggerIdGetResults = qraft.notificationTriggersService.getByIdNotificationTriggersTriggerIdGet.useQueries({
     *     queries: [
     *         {
     *             path: {
     *                 trigger_id: triggerId1
     *             }
     *         },
     *         {
     *             path: {
     *                 trigger_id: triggerId2
     *             }
     *         }
     *     ]
     * });
     * getByIdNotificationTriggersTriggerIdGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const getByIdNotificationTriggersTriggerIdGetCombinedResults = qraft.notificationTriggersService.getByIdNotificationTriggersTriggerIdGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 trigger_id: triggerId1
     *             }
     *         },
     *         {
     *             path: {
     *                 trigger_id: triggerId2
     *             }
     *         }
     *     ]
     * });
     * getByIdNotificationTriggersTriggerIdGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          GetByIdNotificationTriggersTriggerIdGetSchema,
          GetByIdNotificationTriggersTriggerIdGetParameters,
          GetByIdNotificationTriggersTriggerIdGetData,
          GetByIdNotificationTriggersTriggerIdGetError
        >
      >,
      TCombinedResult = Array<
        UseQueryResult<GetByIdNotificationTriggersTriggerIdGetData, GetByIdNotificationTriggersTriggerIdGetError>
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          UseQueryResult<GetByIdNotificationTriggersTriggerIdGetData, GetByIdNotificationTriggersTriggerIdGetError>
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Get By Id
     * @description Get notification trigger by ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.notificationTriggersService.getByIdNotificationTriggersTriggerIdGet.useSuspenseQuery({
     *     path: {
     *         trigger_id: triggerId
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = GetByIdNotificationTriggersTriggerIdGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetByIdNotificationTriggersTriggerIdGetSchema,
            GetByIdNotificationTriggersTriggerIdGetParameters
          >
        | DeepReadonly<GetByIdNotificationTriggersTriggerIdGetParameters>,
      options?: Omit<
        UseSuspenseQueryOptions<
          GetByIdNotificationTriggersTriggerIdGetData,
          GetByIdNotificationTriggersTriggerIdGetError,
          TData,
          ServiceOperationQueryKey<
            GetByIdNotificationTriggersTriggerIdGetSchema,
            GetByIdNotificationTriggersTriggerIdGetParameters
          >
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<GetByIdNotificationTriggersTriggerIdGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Get By Id
     * @description Get notification trigger by ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.notificationTriggersService.getByIdNotificationTriggersTriggerIdGet.useSuspenseInfiniteQuery({
     *     path: {
     *         trigger_id: triggerId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<
      TPageParam extends GetByIdNotificationTriggersTriggerIdGetParameters,
      TData = GetByIdNotificationTriggersTriggerIdGetData,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetByIdNotificationTriggersTriggerIdGetSchema,
            GetByIdNotificationTriggersTriggerIdGetParameters
          >
        | DeepReadonly<GetByIdNotificationTriggersTriggerIdGetParameters>,
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          GetByIdNotificationTriggersTriggerIdGetData,
          GetByIdNotificationTriggersTriggerIdGetError,
          OperationInfiniteData<TData, GetByIdNotificationTriggersTriggerIdGetParameters>,
          ServiceOperationInfiniteQueryKey<
            GetByIdNotificationTriggersTriggerIdGetSchema,
            GetByIdNotificationTriggersTriggerIdGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          GetByIdNotificationTriggersTriggerIdGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, GetByIdNotificationTriggersTriggerIdGetParameters>,
      OperationError<GetByIdNotificationTriggersTriggerIdGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Get By Id
     * @description Get notification trigger by ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const getByIdNotificationTriggersTriggerIdGetData = qraft.notificationTriggersService.getByIdNotificationTriggersTriggerIdGet.useSuspenseQueries({
     *     queries: [
     *         {
     *             path: {
     *                 trigger_id: triggerId1
     *             }
     *         },
     *         {
     *             path: {
     *                 trigger_id: triggerId2
     *             }
     *         }
     *     ]
     * });
     * getByIdNotificationTriggersTriggerIdGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const getByIdNotificationTriggersTriggerIdGetCombinedData = qraft.notificationTriggersService.getByIdNotificationTriggersTriggerIdGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 trigger_id: triggerId1
     *             }
     *         },
     *         {
     *             path: {
     *                 trigger_id: triggerId2
     *             }
     *         }
     *     ]
     * });
     * getByIdNotificationTriggersTriggerIdGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          GetByIdNotificationTriggersTriggerIdGetSchema,
          GetByIdNotificationTriggersTriggerIdGetParameters,
          GetByIdNotificationTriggersTriggerIdGetData,
          GetByIdNotificationTriggersTriggerIdGetError
        >
      >,
      TCombinedResult = Array<
        UseSuspenseQueryResult<
          GetByIdNotificationTriggersTriggerIdGetData,
          GetByIdNotificationTriggersTriggerIdGetError
        >
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<
            UseSuspenseQueryResult<
              GetByIdNotificationTriggersTriggerIdGetData,
              GetByIdNotificationTriggersTriggerIdGetError
            >,
            'data'
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * @summary Get By Id
     * @description Get notification trigger by ID.
     */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetByIdNotificationTriggersTriggerIdGetSchema,
        GetByIdNotificationTriggersTriggerIdGetData,
        GetByIdNotificationTriggersTriggerIdGetParameters,
        GetByIdNotificationTriggersTriggerIdGetError
      >
    ): Promise<GetByIdNotificationTriggersTriggerIdGetData>;
    /**
     * @summary Get By Id
     * @description Get notification trigger by ID.
     */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetByIdNotificationTriggersTriggerIdGetSchema,
        GetByIdNotificationTriggersTriggerIdGetData,
        GetByIdNotificationTriggersTriggerIdGetParameters,
        GetByIdNotificationTriggersTriggerIdGetError
      >
    ): Promise<void>;
    /**
     * @summary Get By Id
     * @description Get notification trigger by ID.
     */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        GetByIdNotificationTriggersTriggerIdGetSchema,
        GetByIdNotificationTriggersTriggerIdGetData,
        GetByIdNotificationTriggersTriggerIdGetParameters,
        GetByIdNotificationTriggersTriggerIdGetError
      >
    ): Promise<GetByIdNotificationTriggersTriggerIdGetData>;
    /**
     * @summary Get By Id
     * @description Get notification trigger by ID.
     */
    fetchInfiniteQuery<TPageParam extends GetByIdNotificationTriggersTriggerIdGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetByIdNotificationTriggersTriggerIdGetSchema,
        GetByIdNotificationTriggersTriggerIdGetData,
        GetByIdNotificationTriggersTriggerIdGetParameters,
        DeepReadonly<TPageParam>,
        GetByIdNotificationTriggersTriggerIdGetError
      >
    ): Promise<
      OperationInfiniteData<
        GetByIdNotificationTriggersTriggerIdGetData,
        GetByIdNotificationTriggersTriggerIdGetParameters
      >
    >;
    /**
     * @summary Get By Id
     * @description Get notification trigger by ID.
     */
    prefetchInfiniteQuery<TPageParam extends GetByIdNotificationTriggersTriggerIdGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetByIdNotificationTriggersTriggerIdGetSchema,
        GetByIdNotificationTriggersTriggerIdGetData,
        GetByIdNotificationTriggersTriggerIdGetParameters,
        DeepReadonly<TPageParam>,
        GetByIdNotificationTriggersTriggerIdGetError
      >
    ): Promise<void>;
    /**
     * @summary Get By Id
     * @description Get notification trigger by ID.
     */
    ensureInfiniteQueryData<TPageParam extends GetByIdNotificationTriggersTriggerIdGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        GetByIdNotificationTriggersTriggerIdGetSchema,
        GetByIdNotificationTriggersTriggerIdGetData,
        GetByIdNotificationTriggersTriggerIdGetParameters,
        DeepReadonly<TPageParam>,
        GetByIdNotificationTriggersTriggerIdGetError
      >
    ): Promise<
      OperationInfiniteData<
        GetByIdNotificationTriggersTriggerIdGetData,
        GetByIdNotificationTriggersTriggerIdGetParameters
      >
    >;
    /**
     * @summary Get By Id
     * @description Get notification trigger by ID.
     */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<
            GetByIdNotificationTriggersTriggerIdGetSchema,
            GetByIdNotificationTriggersTriggerIdGetParameters
          >
        | DeepReadonly<GetByIdNotificationTriggersTriggerIdGetParameters>
    ): GetByIdNotificationTriggersTriggerIdGetData | undefined;
    /**
     * @summary Get By Id
     * @description Get notification trigger by ID.
     */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetByIdNotificationTriggersTriggerIdGetSchema,
            GetByIdNotificationTriggersTriggerIdGetParameters
          >
        | DeepReadonly<GetByIdNotificationTriggersTriggerIdGetParameters>
    ):
      | OperationInfiniteData<
          GetByIdNotificationTriggersTriggerIdGetData,
          GetByIdNotificationTriggersTriggerIdGetParameters
        >
      | undefined;
    /**
     * @summary Get By Id
     * @description Get notification trigger by ID.
     */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetByIdNotificationTriggersTriggerIdGetSchema,
            GetByIdNotificationTriggersTriggerIdGetData,
            TInfinite,
            GetByIdNotificationTriggersTriggerIdGetParameters,
            GetByIdNotificationTriggersTriggerIdGetError
          >
        | QueryFiltersByQueryKey<
            GetByIdNotificationTriggersTriggerIdGetSchema,
            GetByIdNotificationTriggersTriggerIdGetData,
            TInfinite,
            GetByIdNotificationTriggersTriggerIdGetParameters,
            GetByIdNotificationTriggersTriggerIdGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<
              GetByIdNotificationTriggersTriggerIdGetSchema,
              GetByIdNotificationTriggersTriggerIdGetParameters
            >,
            data:
              | NoInfer<
                  OperationInfiniteData<
                    GetByIdNotificationTriggersTriggerIdGetData,
                    GetByIdNotificationTriggersTriggerIdGetParameters
                  >
                >
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<
              GetByIdNotificationTriggersTriggerIdGetSchema,
              GetByIdNotificationTriggersTriggerIdGetParameters
            >,
            data: GetByIdNotificationTriggersTriggerIdGetData | undefined,
          ]
        >;
    /**
     * @summary Get By Id
     * @description Get notification trigger by ID.
     */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<
            GetByIdNotificationTriggersTriggerIdGetSchema,
            GetByIdNotificationTriggersTriggerIdGetParameters
          >
        | DeepReadonly<GetByIdNotificationTriggersTriggerIdGetParameters>
    ):
      | QueryState<GetByIdNotificationTriggersTriggerIdGetData, GetByIdNotificationTriggersTriggerIdGetError>
      | undefined;
    /**
     * @summary Get By Id
     * @description Get notification trigger by ID.
     */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<GetByIdNotificationTriggersTriggerIdGetParameters>
        | ServiceOperationInfiniteQueryKey<
            GetByIdNotificationTriggersTriggerIdGetSchema,
            GetByIdNotificationTriggersTriggerIdGetParameters
          >
    ):
      | QueryState<
          OperationInfiniteData<
            GetByIdNotificationTriggersTriggerIdGetData,
            GetByIdNotificationTriggersTriggerIdGetParameters
          >,
          GetByIdNotificationTriggersTriggerIdGetError
        >
      | undefined;
    /**
     * @summary Get By Id
     * @description Get notification trigger by ID.
     */
    setQueryData(
      parameters:
        | DeepReadonly<GetByIdNotificationTriggersTriggerIdGetParameters>
        | ServiceOperationQueryKey<
            GetByIdNotificationTriggersTriggerIdGetSchema,
            GetByIdNotificationTriggersTriggerIdGetParameters
          >,
      updater: Updater<
        NoInfer<GetByIdNotificationTriggersTriggerIdGetData> | undefined,
        NoInfer<DeepReadonly<GetByIdNotificationTriggersTriggerIdGetData>> | undefined
      >,
      options?: SetDataOptions
    ): GetByIdNotificationTriggersTriggerIdGetData | undefined;
    /**
     * @summary Get By Id
     * @description Get notification trigger by ID.
     */
    setInfiniteQueryData(
      parameters:
        | DeepReadonly<GetByIdNotificationTriggersTriggerIdGetParameters>
        | ServiceOperationInfiniteQueryKey<
            GetByIdNotificationTriggersTriggerIdGetSchema,
            GetByIdNotificationTriggersTriggerIdGetParameters
          >,
      updater: Updater<
        | NoInfer<
            OperationInfiniteData<
              GetByIdNotificationTriggersTriggerIdGetData,
              GetByIdNotificationTriggersTriggerIdGetParameters
            >
          >
        | undefined,
        | NoInfer<
            DeepReadonly<
              OperationInfiniteData<
                GetByIdNotificationTriggersTriggerIdGetData,
                GetByIdNotificationTriggersTriggerIdGetParameters
              >
            >
          >
        | undefined
      >,
      options?: SetDataOptions
    ):
      | OperationInfiniteData<
          GetByIdNotificationTriggersTriggerIdGetData,
          GetByIdNotificationTriggersTriggerIdGetParameters
        >
      | undefined;
    /**
     * @summary Get By Id
     * @description Get notification trigger by ID.
     */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            GetByIdNotificationTriggersTriggerIdGetSchema,
            GetByIdNotificationTriggersTriggerIdGetData,
            TInfinite,
            GetByIdNotificationTriggersTriggerIdGetParameters,
            GetByIdNotificationTriggersTriggerIdGetError
          >
        | QueryFiltersByQueryKey<
            GetByIdNotificationTriggersTriggerIdGetSchema,
            GetByIdNotificationTriggersTriggerIdGetData,
            TInfinite,
            GetByIdNotificationTriggersTriggerIdGetParameters,
            GetByIdNotificationTriggersTriggerIdGetError
          >,
      updater: Updater<
        NoInfer<GetByIdNotificationTriggersTriggerIdGetData> | undefined,
        NoInfer<GetByIdNotificationTriggersTriggerIdGetData> | undefined
      >,
      options?: SetDataOptions
    ): Array<GetByIdNotificationTriggersTriggerIdGetData | undefined>;
    /**
     * @summary Get By Id
     * @description Get notification trigger by ID.
     */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        GetByIdNotificationTriggersTriggerIdGetSchema,
        GetByIdNotificationTriggersTriggerIdGetData,
        TInfinite,
        GetByIdNotificationTriggersTriggerIdGetParameters,
        GetByIdNotificationTriggersTriggerIdGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /**
     * @summary Get By Id
     * @description Get notification trigger by ID.
     */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetByIdNotificationTriggersTriggerIdGetSchema,
            GetByIdNotificationTriggersTriggerIdGetData,
            TInfinite,
            GetByIdNotificationTriggersTriggerIdGetParameters,
            GetByIdNotificationTriggersTriggerIdGetError
          >
        | QueryFiltersByQueryKey<
            GetByIdNotificationTriggersTriggerIdGetSchema,
            GetByIdNotificationTriggersTriggerIdGetData,
            TInfinite,
            GetByIdNotificationTriggersTriggerIdGetParameters,
            GetByIdNotificationTriggersTriggerIdGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /**
     * @summary Get By Id
     * @description Get notification trigger by ID.
     */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetByIdNotificationTriggersTriggerIdGetSchema,
            GetByIdNotificationTriggersTriggerIdGetData,
            TInfinite,
            GetByIdNotificationTriggersTriggerIdGetParameters,
            GetByIdNotificationTriggersTriggerIdGetError
          >
        | QueryFiltersByQueryKey<
            GetByIdNotificationTriggersTriggerIdGetSchema,
            GetByIdNotificationTriggersTriggerIdGetData,
            TInfinite,
            GetByIdNotificationTriggersTriggerIdGetParameters,
            GetByIdNotificationTriggersTriggerIdGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /**
     * @summary Get By Id
     * @description Get notification trigger by ID.
     */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetByIdNotificationTriggersTriggerIdGetSchema,
            GetByIdNotificationTriggersTriggerIdGetData,
            TInfinite,
            GetByIdNotificationTriggersTriggerIdGetParameters,
            GetByIdNotificationTriggersTriggerIdGetError
          >
        | QueryFiltersByQueryKey<
            GetByIdNotificationTriggersTriggerIdGetSchema,
            GetByIdNotificationTriggersTriggerIdGetData,
            TInfinite,
            GetByIdNotificationTriggersTriggerIdGetParameters,
            GetByIdNotificationTriggersTriggerIdGetError
          >
    ): void;
    /**
     * @summary Get By Id
     * @description Get notification trigger by ID.
     */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetByIdNotificationTriggersTriggerIdGetSchema,
            GetByIdNotificationTriggersTriggerIdGetData,
            TInfinite,
            GetByIdNotificationTriggersTriggerIdGetParameters,
            GetByIdNotificationTriggersTriggerIdGetError
          >
        | QueryFiltersByQueryKey<
            GetByIdNotificationTriggersTriggerIdGetSchema,
            GetByIdNotificationTriggersTriggerIdGetData,
            TInfinite,
            GetByIdNotificationTriggersTriggerIdGetParameters,
            GetByIdNotificationTriggersTriggerIdGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /**
     * @summary Get By Id
     * @description Get notification trigger by ID.
     */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetByIdNotificationTriggersTriggerIdGetSchema,
            GetByIdNotificationTriggersTriggerIdGetData,
            TInfinite,
            GetByIdNotificationTriggersTriggerIdGetParameters,
            GetByIdNotificationTriggersTriggerIdGetError
          >
        | QueryFiltersByQueryKey<
            GetByIdNotificationTriggersTriggerIdGetSchema,
            GetByIdNotificationTriggersTriggerIdGetData,
            TInfinite,
            GetByIdNotificationTriggersTriggerIdGetParameters,
            GetByIdNotificationTriggersTriggerIdGetError
          >
    ): number;
    schema: GetByIdNotificationTriggersTriggerIdGetSchema;
    types: {
      parameters: GetByIdNotificationTriggersTriggerIdGetParameters;
      data: GetByIdNotificationTriggersTriggerIdGetData;
      error: GetByIdNotificationTriggersTriggerIdGetError;
    };
  };
  /**
   * @summary Update
   * @description Update an existing notification trigger.
   */
  updateNotificationTriggersTriggerIdPut: {
    /**
     * @summary Update
     * @description Update an existing notification trigger.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        UpdateNotificationTriggersTriggerIdPutBody,
        UpdateNotificationTriggersTriggerIdPutParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: UpdateNotificationTriggersTriggerIdPutSchema,
        options: ServiceOperationMutationFnOptions<
          UpdateNotificationTriggersTriggerIdPutBody,
          UpdateNotificationTriggersTriggerIdPutParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<UpdateNotificationTriggersTriggerIdPutData, UpdateNotificationTriggersTriggerIdPutError>
      >
    ): Promise<
      RequestFnResponse<UpdateNotificationTriggersTriggerIdPutData, UpdateNotificationTriggersTriggerIdPutError>
    >;
    /**
     * @summary Update
     * @description Update an existing notification trigger.
     */
    getMutationKey(
      parameters: DeepReadonly<UpdateNotificationTriggersTriggerIdPutParameters> | void
    ): ServiceOperationMutationKey<
      UpdateNotificationTriggersTriggerIdPutSchema,
      UpdateNotificationTriggersTriggerIdPutParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Update
     * @description Update an existing notification trigger.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.notificationTriggersService.updateNotificationTriggersTriggerIdPut.useMutation({
     *     path: {
     *         trigger_id: triggerId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.notificationTriggersService.updateNotificationTriggersTriggerIdPut.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         trigger_id: triggerId
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends UpdateNotificationTriggersTriggerIdPutBody, TContext = unknown>(
      parameters: DeepReadonly<UpdateNotificationTriggersTriggerIdPutParameters>,
      options?: ServiceOperationUseMutationOptions<
        UpdateNotificationTriggersTriggerIdPutSchema,
        UpdateNotificationTriggersTriggerIdPutData,
        UpdateNotificationTriggersTriggerIdPutParameters,
        TVariables,
        OperationError<UpdateNotificationTriggersTriggerIdPutError>,
        TContext
      >
    ): UseMutationResult<
      UpdateNotificationTriggersTriggerIdPutData,
      OperationError<UpdateNotificationTriggersTriggerIdPutError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Update
     * @description Update an existing notification trigger.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.notificationTriggersService.updateNotificationTriggersTriggerIdPut.useMutation({
     *     path: {
     *         trigger_id: triggerId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.notificationTriggersService.updateNotificationTriggersTriggerIdPut.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         trigger_id: triggerId
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        UpdateNotificationTriggersTriggerIdPutBody,
        UpdateNotificationTriggersTriggerIdPutParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        UpdateNotificationTriggersTriggerIdPutSchema,
        UpdateNotificationTriggersTriggerIdPutData,
        UpdateNotificationTriggersTriggerIdPutParameters,
        TVariables,
        OperationError<UpdateNotificationTriggersTriggerIdPutError>,
        TContext
      >
    ): UseMutationResult<
      UpdateNotificationTriggersTriggerIdPutData,
      OperationError<UpdateNotificationTriggersTriggerIdPutError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Update
     * @description Update an existing notification trigger.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const updateNotificationTriggersTriggerIdPutTotal = qraft.notificationTriggersService.updateNotificationTriggersTriggerIdPut.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const updateNotificationTriggersTriggerIdPutTotal = qraft.notificationTriggersService.updateNotificationTriggersTriggerIdPut.useIsMutating({
     *     parameters: {
     *         path: {
     *             trigger_id: triggerId
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            UpdateNotificationTriggersTriggerIdPutBody,
            UpdateNotificationTriggersTriggerIdPutData,
            UpdateNotificationTriggersTriggerIdPutParameters,
            OperationError<UpdateNotificationTriggersTriggerIdPutError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateNotificationTriggersTriggerIdPutSchema,
            UpdateNotificationTriggersTriggerIdPutBody,
            UpdateNotificationTriggersTriggerIdPutData,
            UpdateNotificationTriggersTriggerIdPutParameters,
            OperationError<UpdateNotificationTriggersTriggerIdPutError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Update
     * @description Update an existing notification trigger.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const updateNotificationTriggersTriggerIdPutPendingMutationVariables = qraft.notificationTriggersService.updateNotificationTriggersTriggerIdPut.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const updateNotificationTriggersTriggerIdPutMutationData = qraft.notificationTriggersService.updateNotificationTriggersTriggerIdPut.useMutationState({
     *     filters: {
     *         parameters: {
     *             path: {
     *                 trigger_id: triggerId
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        UpdateNotificationTriggersTriggerIdPutData,
        OperationError<UpdateNotificationTriggersTriggerIdPutError>,
        MutationVariables<UpdateNotificationTriggersTriggerIdPutBody, UpdateNotificationTriggersTriggerIdPutParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            UpdateNotificationTriggersTriggerIdPutBody,
            UpdateNotificationTriggersTriggerIdPutData,
            UpdateNotificationTriggersTriggerIdPutParameters,
            OperationError<UpdateNotificationTriggersTriggerIdPutError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateNotificationTriggersTriggerIdPutSchema,
            UpdateNotificationTriggersTriggerIdPutBody,
            UpdateNotificationTriggersTriggerIdPutData,
            UpdateNotificationTriggersTriggerIdPutParameters,
            OperationError<UpdateNotificationTriggersTriggerIdPutError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          UpdateNotificationTriggersTriggerIdPutData,
          OperationError<UpdateNotificationTriggersTriggerIdPutError>,
          MutationVariables<
            UpdateNotificationTriggersTriggerIdPutBody,
            UpdateNotificationTriggersTriggerIdPutParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Update
     * @description Update an existing notification trigger.
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            UpdateNotificationTriggersTriggerIdPutBody,
            UpdateNotificationTriggersTriggerIdPutData,
            UpdateNotificationTriggersTriggerIdPutParameters,
            OperationError<UpdateNotificationTriggersTriggerIdPutError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateNotificationTriggersTriggerIdPutSchema,
            UpdateNotificationTriggersTriggerIdPutBody,
            UpdateNotificationTriggersTriggerIdPutData,
            UpdateNotificationTriggersTriggerIdPutParameters,
            OperationError<UpdateNotificationTriggersTriggerIdPutError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Update
     * @description Update an existing notification trigger.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.notificationTriggersService.updateNotificationTriggersTriggerIdPut.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         path: {
     *             trigger_id: triggerId
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.notificationTriggersService.updateNotificationTriggersTriggerIdPut.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              UpdateNotificationTriggersTriggerIdPutBody,
              UpdateNotificationTriggersTriggerIdPutData,
              UpdateNotificationTriggersTriggerIdPutParameters,
              OperationError<UpdateNotificationTriggersTriggerIdPutError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              UpdateNotificationTriggersTriggerIdPutSchema,
              UpdateNotificationTriggersTriggerIdPutBody,
              UpdateNotificationTriggersTriggerIdPutData,
              UpdateNotificationTriggersTriggerIdPutParameters,
              OperationError<UpdateNotificationTriggersTriggerIdPutError>,
              TContext
            >
      ):
        | Mutation<
            UpdateNotificationTriggersTriggerIdPutData,
            UpdateNotificationTriggersTriggerIdPutError,
            MutationVariables<
              UpdateNotificationTriggersTriggerIdPutBody,
              UpdateNotificationTriggersTriggerIdPutParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              UpdateNotificationTriggersTriggerIdPutBody,
              UpdateNotificationTriggersTriggerIdPutData,
              UpdateNotificationTriggersTriggerIdPutParameters,
              OperationError<UpdateNotificationTriggersTriggerIdPutError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              UpdateNotificationTriggersTriggerIdPutSchema,
              UpdateNotificationTriggersTriggerIdPutBody,
              UpdateNotificationTriggersTriggerIdPutData,
              UpdateNotificationTriggersTriggerIdPutParameters,
              OperationError<UpdateNotificationTriggersTriggerIdPutError>,
              TContext
            >
      ): Array<
        Mutation<
          UpdateNotificationTriggersTriggerIdPutData,
          UpdateNotificationTriggersTriggerIdPutError,
          MutationVariables<
            UpdateNotificationTriggersTriggerIdPutBody,
            UpdateNotificationTriggersTriggerIdPutParameters
          >,
          TContext
        >
      >;
    };
    schema: UpdateNotificationTriggersTriggerIdPutSchema;
    types: {
      parameters: UpdateNotificationTriggersTriggerIdPutParameters;
      data: UpdateNotificationTriggersTriggerIdPutData;
      error: UpdateNotificationTriggersTriggerIdPutError;
      body: UpdateNotificationTriggersTriggerIdPutBody;
    };
  };
  /**
   * @summary Delete
   * @description Delete a notification trigger.
   */
  deleteNotificationTriggersTriggerIdDelete: {
    /**
     * @summary Delete
     * @description Delete a notification trigger.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        DeleteNotificationTriggersTriggerIdDeleteBody,
        DeleteNotificationTriggersTriggerIdDeleteParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: DeleteNotificationTriggersTriggerIdDeleteSchema,
        options: ServiceOperationMutationFnOptions<
          DeleteNotificationTriggersTriggerIdDeleteBody,
          DeleteNotificationTriggersTriggerIdDeleteParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<DeleteNotificationTriggersTriggerIdDeleteData, DeleteNotificationTriggersTriggerIdDeleteError>
      >
    ): Promise<
      RequestFnResponse<DeleteNotificationTriggersTriggerIdDeleteData, DeleteNotificationTriggersTriggerIdDeleteError>
    >;
    /**
     * @summary Delete
     * @description Delete a notification trigger.
     */
    getMutationKey(
      parameters: DeepReadonly<DeleteNotificationTriggersTriggerIdDeleteParameters> | void
    ): ServiceOperationMutationKey<
      DeleteNotificationTriggersTriggerIdDeleteSchema,
      DeleteNotificationTriggersTriggerIdDeleteParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Delete
     * @description Delete a notification trigger.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.notificationTriggersService.deleteNotificationTriggersTriggerIdDelete.useMutation({
     *     path: {
     *         trigger_id: triggerId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.notificationTriggersService.deleteNotificationTriggersTriggerIdDelete.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         trigger_id: triggerId
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends DeleteNotificationTriggersTriggerIdDeleteBody, TContext = unknown>(
      parameters: DeepReadonly<DeleteNotificationTriggersTriggerIdDeleteParameters>,
      options?: ServiceOperationUseMutationOptions<
        DeleteNotificationTriggersTriggerIdDeleteSchema,
        DeleteNotificationTriggersTriggerIdDeleteData,
        DeleteNotificationTriggersTriggerIdDeleteParameters,
        TVariables,
        OperationError<DeleteNotificationTriggersTriggerIdDeleteError>,
        TContext
      >
    ): UseMutationResult<
      DeleteNotificationTriggersTriggerIdDeleteData,
      OperationError<DeleteNotificationTriggersTriggerIdDeleteError>,
      TVariables | void,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Delete
     * @description Delete a notification trigger.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.notificationTriggersService.deleteNotificationTriggersTriggerIdDelete.useMutation({
     *     path: {
     *         trigger_id: triggerId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.notificationTriggersService.deleteNotificationTriggersTriggerIdDelete.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         trigger_id: triggerId
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        DeleteNotificationTriggersTriggerIdDeleteBody,
        DeleteNotificationTriggersTriggerIdDeleteParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        DeleteNotificationTriggersTriggerIdDeleteSchema,
        DeleteNotificationTriggersTriggerIdDeleteData,
        DeleteNotificationTriggersTriggerIdDeleteParameters,
        TVariables,
        OperationError<DeleteNotificationTriggersTriggerIdDeleteError>,
        TContext
      >
    ): UseMutationResult<
      DeleteNotificationTriggersTriggerIdDeleteData,
      OperationError<DeleteNotificationTriggersTriggerIdDeleteError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Delete
     * @description Delete a notification trigger.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const deleteNotificationTriggersTriggerIdDeleteTotal = qraft.notificationTriggersService.deleteNotificationTriggersTriggerIdDelete.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const deleteNotificationTriggersTriggerIdDeleteTotal = qraft.notificationTriggersService.deleteNotificationTriggersTriggerIdDelete.useIsMutating({
     *     parameters: {
     *         path: {
     *             trigger_id: triggerId
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            DeleteNotificationTriggersTriggerIdDeleteBody,
            DeleteNotificationTriggersTriggerIdDeleteData,
            DeleteNotificationTriggersTriggerIdDeleteParameters,
            OperationError<DeleteNotificationTriggersTriggerIdDeleteError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            DeleteNotificationTriggersTriggerIdDeleteSchema,
            DeleteNotificationTriggersTriggerIdDeleteBody,
            DeleteNotificationTriggersTriggerIdDeleteData,
            DeleteNotificationTriggersTriggerIdDeleteParameters,
            OperationError<DeleteNotificationTriggersTriggerIdDeleteError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Delete
     * @description Delete a notification trigger.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const deleteNotificationTriggersTriggerIdDeletePendingMutationVariables = qraft.notificationTriggersService.deleteNotificationTriggersTriggerIdDelete.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const deleteNotificationTriggersTriggerIdDeleteMutationData = qraft.notificationTriggersService.deleteNotificationTriggersTriggerIdDelete.useMutationState({
     *     filters: {
     *         parameters: {
     *             path: {
     *                 trigger_id: triggerId
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        DeleteNotificationTriggersTriggerIdDeleteData,
        OperationError<DeleteNotificationTriggersTriggerIdDeleteError>,
        MutationVariables<
          DeleteNotificationTriggersTriggerIdDeleteBody,
          DeleteNotificationTriggersTriggerIdDeleteParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            DeleteNotificationTriggersTriggerIdDeleteBody,
            DeleteNotificationTriggersTriggerIdDeleteData,
            DeleteNotificationTriggersTriggerIdDeleteParameters,
            OperationError<DeleteNotificationTriggersTriggerIdDeleteError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            DeleteNotificationTriggersTriggerIdDeleteSchema,
            DeleteNotificationTriggersTriggerIdDeleteBody,
            DeleteNotificationTriggersTriggerIdDeleteData,
            DeleteNotificationTriggersTriggerIdDeleteParameters,
            OperationError<DeleteNotificationTriggersTriggerIdDeleteError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          DeleteNotificationTriggersTriggerIdDeleteData,
          OperationError<DeleteNotificationTriggersTriggerIdDeleteError>,
          MutationVariables<
            DeleteNotificationTriggersTriggerIdDeleteBody,
            DeleteNotificationTriggersTriggerIdDeleteParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Delete
     * @description Delete a notification trigger.
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            DeleteNotificationTriggersTriggerIdDeleteBody,
            DeleteNotificationTriggersTriggerIdDeleteData,
            DeleteNotificationTriggersTriggerIdDeleteParameters,
            OperationError<DeleteNotificationTriggersTriggerIdDeleteError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            DeleteNotificationTriggersTriggerIdDeleteSchema,
            DeleteNotificationTriggersTriggerIdDeleteBody,
            DeleteNotificationTriggersTriggerIdDeleteData,
            DeleteNotificationTriggersTriggerIdDeleteParameters,
            OperationError<DeleteNotificationTriggersTriggerIdDeleteError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Delete
     * @description Delete a notification trigger.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.notificationTriggersService.deleteNotificationTriggersTriggerIdDelete.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         path: {
     *             trigger_id: triggerId
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.notificationTriggersService.deleteNotificationTriggersTriggerIdDelete.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              DeleteNotificationTriggersTriggerIdDeleteBody,
              DeleteNotificationTriggersTriggerIdDeleteData,
              DeleteNotificationTriggersTriggerIdDeleteParameters,
              OperationError<DeleteNotificationTriggersTriggerIdDeleteError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              DeleteNotificationTriggersTriggerIdDeleteSchema,
              DeleteNotificationTriggersTriggerIdDeleteBody,
              DeleteNotificationTriggersTriggerIdDeleteData,
              DeleteNotificationTriggersTriggerIdDeleteParameters,
              OperationError<DeleteNotificationTriggersTriggerIdDeleteError>,
              TContext
            >
      ):
        | Mutation<
            DeleteNotificationTriggersTriggerIdDeleteData,
            DeleteNotificationTriggersTriggerIdDeleteError,
            MutationVariables<
              DeleteNotificationTriggersTriggerIdDeleteBody,
              DeleteNotificationTriggersTriggerIdDeleteParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              DeleteNotificationTriggersTriggerIdDeleteBody,
              DeleteNotificationTriggersTriggerIdDeleteData,
              DeleteNotificationTriggersTriggerIdDeleteParameters,
              OperationError<DeleteNotificationTriggersTriggerIdDeleteError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              DeleteNotificationTriggersTriggerIdDeleteSchema,
              DeleteNotificationTriggersTriggerIdDeleteBody,
              DeleteNotificationTriggersTriggerIdDeleteData,
              DeleteNotificationTriggersTriggerIdDeleteParameters,
              OperationError<DeleteNotificationTriggersTriggerIdDeleteError>,
              TContext
            >
      ): Array<
        Mutation<
          DeleteNotificationTriggersTriggerIdDeleteData,
          DeleteNotificationTriggersTriggerIdDeleteError,
          MutationVariables<
            DeleteNotificationTriggersTriggerIdDeleteBody,
            DeleteNotificationTriggersTriggerIdDeleteParameters
          >,
          TContext
        >
      >;
    };
    schema: DeleteNotificationTriggersTriggerIdDeleteSchema;
    types: {
      parameters: DeleteNotificationTriggersTriggerIdDeleteParameters;
      data: DeleteNotificationTriggersTriggerIdDeleteData;
      error: DeleteNotificationTriggersTriggerIdDeleteError;
      body: DeleteNotificationTriggersTriggerIdDeleteBody;
    };
  };
  /** @summary Get Filters */
  getFiltersNotificationTriggersFiltersTypeGet: {
    /** @summary Get Filters */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<
            GetFiltersNotificationTriggersFiltersTypeGetSchema,
            GetFiltersNotificationTriggersFiltersTypeGetParameters,
            TMeta,
            TSignal
          >
        | QueryFnOptionsByParameters<GetFiltersNotificationTriggersFiltersTypeGetParameters, TMeta, TSignal>,
      client?: (
        schema: GetFiltersNotificationTriggersFiltersTypeGetSchema,
        options: {
          parameters: GetFiltersNotificationTriggersFiltersTypeGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<
        RequestFnResponse<
          GetFiltersNotificationTriggersFiltersTypeGetData,
          GetFiltersNotificationTriggersFiltersTypeGetError
        >
      >
    ): Promise<
      RequestFnResponse<
        GetFiltersNotificationTriggersFiltersTypeGetData,
        GetFiltersNotificationTriggersFiltersTypeGetError
      >
    >;
    /** @summary Get Filters */
    getQueryKey(
      parameters: DeepReadonly<GetFiltersNotificationTriggersFiltersTypeGetParameters>
    ): ServiceOperationQueryKey<
      GetFiltersNotificationTriggersFiltersTypeGetSchema,
      GetFiltersNotificationTriggersFiltersTypeGetParameters
    >;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get Filters
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.notificationTriggersService.getFiltersNotificationTriggersFiltersTypeGet.useQuery({
     *     path: {
     *         type: type
     *     }
     * })
     * ```
     */
    useQuery<TData = GetFiltersNotificationTriggersFiltersTypeGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetFiltersNotificationTriggersFiltersTypeGetSchema,
            GetFiltersNotificationTriggersFiltersTypeGetParameters
          >
        | DeepReadonly<GetFiltersNotificationTriggersFiltersTypeGetParameters>,
      options?: Omit<
        UndefinedInitialDataOptions<
          GetFiltersNotificationTriggersFiltersTypeGetData,
          GetFiltersNotificationTriggersFiltersTypeGetError,
          TData,
          ServiceOperationQueryKey<
            GetFiltersNotificationTriggersFiltersTypeGetSchema,
            GetFiltersNotificationTriggersFiltersTypeGetParameters
          >
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<GetFiltersNotificationTriggersFiltersTypeGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get Filters
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.notificationTriggersService.getFiltersNotificationTriggersFiltersTypeGet.useQuery({
     *     path: {
     *         type: type
     *     }
     * })
     * ```
     */
    useQuery<TData = GetFiltersNotificationTriggersFiltersTypeGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetFiltersNotificationTriggersFiltersTypeGetSchema,
            GetFiltersNotificationTriggersFiltersTypeGetParameters
          >
        | DeepReadonly<GetFiltersNotificationTriggersFiltersTypeGetParameters>,
      options: Omit<
        DefinedInitialDataOptions<
          GetFiltersNotificationTriggersFiltersTypeGetData,
          GetFiltersNotificationTriggersFiltersTypeGetError,
          TData,
          ServiceOperationQueryKey<
            GetFiltersNotificationTriggersFiltersTypeGetSchema,
            GetFiltersNotificationTriggersFiltersTypeGetParameters
          >
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<GetFiltersNotificationTriggersFiltersTypeGetError>>;
    /** @summary Get Filters */
    getInfiniteQueryKey(
      parameters: DeepReadonly<GetFiltersNotificationTriggersFiltersTypeGetParameters>
    ): ServiceOperationInfiniteQueryKey<
      GetFiltersNotificationTriggersFiltersTypeGetSchema,
      GetFiltersNotificationTriggersFiltersTypeGetParameters
    >;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get Filters
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.notificationTriggersService.getFiltersNotificationTriggersFiltersTypeGet.useInfiniteQuery({
     *     path: {
     *         type: type
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetFiltersNotificationTriggersFiltersTypeGetParameters,
      TQueryFnData = GetFiltersNotificationTriggersFiltersTypeGetData,
      TData = OperationInfiniteData<TQueryFnData, GetFiltersNotificationTriggersFiltersTypeGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetFiltersNotificationTriggersFiltersTypeGetSchema,
            GetFiltersNotificationTriggersFiltersTypeGetParameters
          >
        | DeepReadonly<GetFiltersNotificationTriggersFiltersTypeGetParameters>,
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetFiltersNotificationTriggersFiltersTypeGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            GetFiltersNotificationTriggersFiltersTypeGetSchema,
            GetFiltersNotificationTriggersFiltersTypeGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<GetFiltersNotificationTriggersFiltersTypeGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get Filters
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.notificationTriggersService.getFiltersNotificationTriggersFiltersTypeGet.useInfiniteQuery({
     *     path: {
     *         type: type
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetFiltersNotificationTriggersFiltersTypeGetParameters,
      TQueryFnData = GetFiltersNotificationTriggersFiltersTypeGetData,
      TData = OperationInfiniteData<TQueryFnData, GetFiltersNotificationTriggersFiltersTypeGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetFiltersNotificationTriggersFiltersTypeGetSchema,
            GetFiltersNotificationTriggersFiltersTypeGetParameters
          >
        | DeepReadonly<GetFiltersNotificationTriggersFiltersTypeGetParameters>,
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetFiltersNotificationTriggersFiltersTypeGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            GetFiltersNotificationTriggersFiltersTypeGetSchema,
            GetFiltersNotificationTriggersFiltersTypeGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          GetFiltersNotificationTriggersFiltersTypeGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): DefinedUseInfiniteQueryResult<TData, OperationError<GetFiltersNotificationTriggersFiltersTypeGetError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Get Filters
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const getFiltersNotificationTriggersFiltersTypeGetTotal = qraft.notificationTriggersService.getFiltersNotificationTriggersFiltersTypeGet.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const getFiltersNotificationTriggersFiltersTypeGetByParametersTotal = qraft.notificationTriggersService.getFiltersNotificationTriggersFiltersTypeGet.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         path: {
     *             type: type
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetFiltersNotificationTriggersFiltersTypeGetSchema,
            GetFiltersNotificationTriggersFiltersTypeGetData,
            TInfinite,
            GetFiltersNotificationTriggersFiltersTypeGetParameters,
            GetFiltersNotificationTriggersFiltersTypeGetError
          >
        | QueryFiltersByQueryKey<
            GetFiltersNotificationTriggersFiltersTypeGetSchema,
            GetFiltersNotificationTriggersFiltersTypeGetData,
            TInfinite,
            GetFiltersNotificationTriggersFiltersTypeGetParameters,
            GetFiltersNotificationTriggersFiltersTypeGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Get Filters
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const getFiltersNotificationTriggersFiltersTypeGetResults = qraft.notificationTriggersService.getFiltersNotificationTriggersFiltersTypeGet.useQueries({
     *     queries: [
     *         {
     *             path: {
     *                 type: type1
     *             }
     *         },
     *         {
     *             path: {
     *                 type: type2
     *             }
     *         }
     *     ]
     * });
     * getFiltersNotificationTriggersFiltersTypeGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const getFiltersNotificationTriggersFiltersTypeGetCombinedResults = qraft.notificationTriggersService.getFiltersNotificationTriggersFiltersTypeGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 type: type1
     *             }
     *         },
     *         {
     *             path: {
     *                 type: type2
     *             }
     *         }
     *     ]
     * });
     * getFiltersNotificationTriggersFiltersTypeGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          GetFiltersNotificationTriggersFiltersTypeGetSchema,
          GetFiltersNotificationTriggersFiltersTypeGetParameters,
          GetFiltersNotificationTriggersFiltersTypeGetData,
          GetFiltersNotificationTriggersFiltersTypeGetError
        >
      >,
      TCombinedResult = Array<
        UseQueryResult<
          GetFiltersNotificationTriggersFiltersTypeGetData,
          GetFiltersNotificationTriggersFiltersTypeGetError
        >
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          UseQueryResult<
            GetFiltersNotificationTriggersFiltersTypeGetData,
            GetFiltersNotificationTriggersFiltersTypeGetError
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Get Filters
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.notificationTriggersService.getFiltersNotificationTriggersFiltersTypeGet.useSuspenseQuery({
     *     path: {
     *         type: type
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = GetFiltersNotificationTriggersFiltersTypeGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetFiltersNotificationTriggersFiltersTypeGetSchema,
            GetFiltersNotificationTriggersFiltersTypeGetParameters
          >
        | DeepReadonly<GetFiltersNotificationTriggersFiltersTypeGetParameters>,
      options?: Omit<
        UseSuspenseQueryOptions<
          GetFiltersNotificationTriggersFiltersTypeGetData,
          GetFiltersNotificationTriggersFiltersTypeGetError,
          TData,
          ServiceOperationQueryKey<
            GetFiltersNotificationTriggersFiltersTypeGetSchema,
            GetFiltersNotificationTriggersFiltersTypeGetParameters
          >
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<GetFiltersNotificationTriggersFiltersTypeGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Get Filters
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.notificationTriggersService.getFiltersNotificationTriggersFiltersTypeGet.useSuspenseInfiniteQuery({
     *     path: {
     *         type: type
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<
      TPageParam extends GetFiltersNotificationTriggersFiltersTypeGetParameters,
      TData = GetFiltersNotificationTriggersFiltersTypeGetData,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetFiltersNotificationTriggersFiltersTypeGetSchema,
            GetFiltersNotificationTriggersFiltersTypeGetParameters
          >
        | DeepReadonly<GetFiltersNotificationTriggersFiltersTypeGetParameters>,
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          GetFiltersNotificationTriggersFiltersTypeGetData,
          GetFiltersNotificationTriggersFiltersTypeGetError,
          OperationInfiniteData<TData, GetFiltersNotificationTriggersFiltersTypeGetParameters>,
          ServiceOperationInfiniteQueryKey<
            GetFiltersNotificationTriggersFiltersTypeGetSchema,
            GetFiltersNotificationTriggersFiltersTypeGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          GetFiltersNotificationTriggersFiltersTypeGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, GetFiltersNotificationTriggersFiltersTypeGetParameters>,
      OperationError<GetFiltersNotificationTriggersFiltersTypeGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Get Filters
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const getFiltersNotificationTriggersFiltersTypeGetData = qraft.notificationTriggersService.getFiltersNotificationTriggersFiltersTypeGet.useSuspenseQueries({
     *     queries: [
     *         {
     *             path: {
     *                 type: type1
     *             }
     *         },
     *         {
     *             path: {
     *                 type: type2
     *             }
     *         }
     *     ]
     * });
     * getFiltersNotificationTriggersFiltersTypeGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const getFiltersNotificationTriggersFiltersTypeGetCombinedData = qraft.notificationTriggersService.getFiltersNotificationTriggersFiltersTypeGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 type: type1
     *             }
     *         },
     *         {
     *             path: {
     *                 type: type2
     *             }
     *         }
     *     ]
     * });
     * getFiltersNotificationTriggersFiltersTypeGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          GetFiltersNotificationTriggersFiltersTypeGetSchema,
          GetFiltersNotificationTriggersFiltersTypeGetParameters,
          GetFiltersNotificationTriggersFiltersTypeGetData,
          GetFiltersNotificationTriggersFiltersTypeGetError
        >
      >,
      TCombinedResult = Array<
        UseSuspenseQueryResult<
          GetFiltersNotificationTriggersFiltersTypeGetData,
          GetFiltersNotificationTriggersFiltersTypeGetError
        >
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<
            UseSuspenseQueryResult<
              GetFiltersNotificationTriggersFiltersTypeGetData,
              GetFiltersNotificationTriggersFiltersTypeGetError
            >,
            'data'
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /** @summary Get Filters */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetFiltersNotificationTriggersFiltersTypeGetSchema,
        GetFiltersNotificationTriggersFiltersTypeGetData,
        GetFiltersNotificationTriggersFiltersTypeGetParameters,
        GetFiltersNotificationTriggersFiltersTypeGetError
      >
    ): Promise<GetFiltersNotificationTriggersFiltersTypeGetData>;
    /** @summary Get Filters */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetFiltersNotificationTriggersFiltersTypeGetSchema,
        GetFiltersNotificationTriggersFiltersTypeGetData,
        GetFiltersNotificationTriggersFiltersTypeGetParameters,
        GetFiltersNotificationTriggersFiltersTypeGetError
      >
    ): Promise<void>;
    /** @summary Get Filters */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        GetFiltersNotificationTriggersFiltersTypeGetSchema,
        GetFiltersNotificationTriggersFiltersTypeGetData,
        GetFiltersNotificationTriggersFiltersTypeGetParameters,
        GetFiltersNotificationTriggersFiltersTypeGetError
      >
    ): Promise<GetFiltersNotificationTriggersFiltersTypeGetData>;
    /** @summary Get Filters */
    fetchInfiniteQuery<TPageParam extends GetFiltersNotificationTriggersFiltersTypeGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetFiltersNotificationTriggersFiltersTypeGetSchema,
        GetFiltersNotificationTriggersFiltersTypeGetData,
        GetFiltersNotificationTriggersFiltersTypeGetParameters,
        DeepReadonly<TPageParam>,
        GetFiltersNotificationTriggersFiltersTypeGetError
      >
    ): Promise<
      OperationInfiniteData<
        GetFiltersNotificationTriggersFiltersTypeGetData,
        GetFiltersNotificationTriggersFiltersTypeGetParameters
      >
    >;
    /** @summary Get Filters */
    prefetchInfiniteQuery<TPageParam extends GetFiltersNotificationTriggersFiltersTypeGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetFiltersNotificationTriggersFiltersTypeGetSchema,
        GetFiltersNotificationTriggersFiltersTypeGetData,
        GetFiltersNotificationTriggersFiltersTypeGetParameters,
        DeepReadonly<TPageParam>,
        GetFiltersNotificationTriggersFiltersTypeGetError
      >
    ): Promise<void>;
    /** @summary Get Filters */
    ensureInfiniteQueryData<TPageParam extends GetFiltersNotificationTriggersFiltersTypeGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        GetFiltersNotificationTriggersFiltersTypeGetSchema,
        GetFiltersNotificationTriggersFiltersTypeGetData,
        GetFiltersNotificationTriggersFiltersTypeGetParameters,
        DeepReadonly<TPageParam>,
        GetFiltersNotificationTriggersFiltersTypeGetError
      >
    ): Promise<
      OperationInfiniteData<
        GetFiltersNotificationTriggersFiltersTypeGetData,
        GetFiltersNotificationTriggersFiltersTypeGetParameters
      >
    >;
    /** @summary Get Filters */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<
            GetFiltersNotificationTriggersFiltersTypeGetSchema,
            GetFiltersNotificationTriggersFiltersTypeGetParameters
          >
        | DeepReadonly<GetFiltersNotificationTriggersFiltersTypeGetParameters>
    ): GetFiltersNotificationTriggersFiltersTypeGetData | undefined;
    /** @summary Get Filters */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetFiltersNotificationTriggersFiltersTypeGetSchema,
            GetFiltersNotificationTriggersFiltersTypeGetParameters
          >
        | DeepReadonly<GetFiltersNotificationTriggersFiltersTypeGetParameters>
    ):
      | OperationInfiniteData<
          GetFiltersNotificationTriggersFiltersTypeGetData,
          GetFiltersNotificationTriggersFiltersTypeGetParameters
        >
      | undefined;
    /** @summary Get Filters */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetFiltersNotificationTriggersFiltersTypeGetSchema,
            GetFiltersNotificationTriggersFiltersTypeGetData,
            TInfinite,
            GetFiltersNotificationTriggersFiltersTypeGetParameters,
            GetFiltersNotificationTriggersFiltersTypeGetError
          >
        | QueryFiltersByQueryKey<
            GetFiltersNotificationTriggersFiltersTypeGetSchema,
            GetFiltersNotificationTriggersFiltersTypeGetData,
            TInfinite,
            GetFiltersNotificationTriggersFiltersTypeGetParameters,
            GetFiltersNotificationTriggersFiltersTypeGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<
              GetFiltersNotificationTriggersFiltersTypeGetSchema,
              GetFiltersNotificationTriggersFiltersTypeGetParameters
            >,
            data:
              | NoInfer<
                  OperationInfiniteData<
                    GetFiltersNotificationTriggersFiltersTypeGetData,
                    GetFiltersNotificationTriggersFiltersTypeGetParameters
                  >
                >
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<
              GetFiltersNotificationTriggersFiltersTypeGetSchema,
              GetFiltersNotificationTriggersFiltersTypeGetParameters
            >,
            data: GetFiltersNotificationTriggersFiltersTypeGetData | undefined,
          ]
        >;
    /** @summary Get Filters */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<
            GetFiltersNotificationTriggersFiltersTypeGetSchema,
            GetFiltersNotificationTriggersFiltersTypeGetParameters
          >
        | DeepReadonly<GetFiltersNotificationTriggersFiltersTypeGetParameters>
    ):
      | QueryState<GetFiltersNotificationTriggersFiltersTypeGetData, GetFiltersNotificationTriggersFiltersTypeGetError>
      | undefined;
    /** @summary Get Filters */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<GetFiltersNotificationTriggersFiltersTypeGetParameters>
        | ServiceOperationInfiniteQueryKey<
            GetFiltersNotificationTriggersFiltersTypeGetSchema,
            GetFiltersNotificationTriggersFiltersTypeGetParameters
          >
    ):
      | QueryState<
          OperationInfiniteData<
            GetFiltersNotificationTriggersFiltersTypeGetData,
            GetFiltersNotificationTriggersFiltersTypeGetParameters
          >,
          GetFiltersNotificationTriggersFiltersTypeGetError
        >
      | undefined;
    /** @summary Get Filters */
    setQueryData(
      parameters:
        | DeepReadonly<GetFiltersNotificationTriggersFiltersTypeGetParameters>
        | ServiceOperationQueryKey<
            GetFiltersNotificationTriggersFiltersTypeGetSchema,
            GetFiltersNotificationTriggersFiltersTypeGetParameters
          >,
      updater: Updater<
        NoInfer<GetFiltersNotificationTriggersFiltersTypeGetData> | undefined,
        NoInfer<DeepReadonly<GetFiltersNotificationTriggersFiltersTypeGetData>> | undefined
      >,
      options?: SetDataOptions
    ): GetFiltersNotificationTriggersFiltersTypeGetData | undefined;
    /** @summary Get Filters */
    setInfiniteQueryData(
      parameters:
        | DeepReadonly<GetFiltersNotificationTriggersFiltersTypeGetParameters>
        | ServiceOperationInfiniteQueryKey<
            GetFiltersNotificationTriggersFiltersTypeGetSchema,
            GetFiltersNotificationTriggersFiltersTypeGetParameters
          >,
      updater: Updater<
        | NoInfer<
            OperationInfiniteData<
              GetFiltersNotificationTriggersFiltersTypeGetData,
              GetFiltersNotificationTriggersFiltersTypeGetParameters
            >
          >
        | undefined,
        | NoInfer<
            DeepReadonly<
              OperationInfiniteData<
                GetFiltersNotificationTriggersFiltersTypeGetData,
                GetFiltersNotificationTriggersFiltersTypeGetParameters
              >
            >
          >
        | undefined
      >,
      options?: SetDataOptions
    ):
      | OperationInfiniteData<
          GetFiltersNotificationTriggersFiltersTypeGetData,
          GetFiltersNotificationTriggersFiltersTypeGetParameters
        >
      | undefined;
    /** @summary Get Filters */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            GetFiltersNotificationTriggersFiltersTypeGetSchema,
            GetFiltersNotificationTriggersFiltersTypeGetData,
            TInfinite,
            GetFiltersNotificationTriggersFiltersTypeGetParameters,
            GetFiltersNotificationTriggersFiltersTypeGetError
          >
        | QueryFiltersByQueryKey<
            GetFiltersNotificationTriggersFiltersTypeGetSchema,
            GetFiltersNotificationTriggersFiltersTypeGetData,
            TInfinite,
            GetFiltersNotificationTriggersFiltersTypeGetParameters,
            GetFiltersNotificationTriggersFiltersTypeGetError
          >,
      updater: Updater<
        NoInfer<GetFiltersNotificationTriggersFiltersTypeGetData> | undefined,
        NoInfer<GetFiltersNotificationTriggersFiltersTypeGetData> | undefined
      >,
      options?: SetDataOptions
    ): Array<GetFiltersNotificationTriggersFiltersTypeGetData | undefined>;
    /** @summary Get Filters */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        GetFiltersNotificationTriggersFiltersTypeGetSchema,
        GetFiltersNotificationTriggersFiltersTypeGetData,
        TInfinite,
        GetFiltersNotificationTriggersFiltersTypeGetParameters,
        GetFiltersNotificationTriggersFiltersTypeGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /** @summary Get Filters */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetFiltersNotificationTriggersFiltersTypeGetSchema,
            GetFiltersNotificationTriggersFiltersTypeGetData,
            TInfinite,
            GetFiltersNotificationTriggersFiltersTypeGetParameters,
            GetFiltersNotificationTriggersFiltersTypeGetError
          >
        | QueryFiltersByQueryKey<
            GetFiltersNotificationTriggersFiltersTypeGetSchema,
            GetFiltersNotificationTriggersFiltersTypeGetData,
            TInfinite,
            GetFiltersNotificationTriggersFiltersTypeGetParameters,
            GetFiltersNotificationTriggersFiltersTypeGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /** @summary Get Filters */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetFiltersNotificationTriggersFiltersTypeGetSchema,
            GetFiltersNotificationTriggersFiltersTypeGetData,
            TInfinite,
            GetFiltersNotificationTriggersFiltersTypeGetParameters,
            GetFiltersNotificationTriggersFiltersTypeGetError
          >
        | QueryFiltersByQueryKey<
            GetFiltersNotificationTriggersFiltersTypeGetSchema,
            GetFiltersNotificationTriggersFiltersTypeGetData,
            TInfinite,
            GetFiltersNotificationTriggersFiltersTypeGetParameters,
            GetFiltersNotificationTriggersFiltersTypeGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /** @summary Get Filters */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetFiltersNotificationTriggersFiltersTypeGetSchema,
            GetFiltersNotificationTriggersFiltersTypeGetData,
            TInfinite,
            GetFiltersNotificationTriggersFiltersTypeGetParameters,
            GetFiltersNotificationTriggersFiltersTypeGetError
          >
        | QueryFiltersByQueryKey<
            GetFiltersNotificationTriggersFiltersTypeGetSchema,
            GetFiltersNotificationTriggersFiltersTypeGetData,
            TInfinite,
            GetFiltersNotificationTriggersFiltersTypeGetParameters,
            GetFiltersNotificationTriggersFiltersTypeGetError
          >
    ): void;
    /** @summary Get Filters */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetFiltersNotificationTriggersFiltersTypeGetSchema,
            GetFiltersNotificationTriggersFiltersTypeGetData,
            TInfinite,
            GetFiltersNotificationTriggersFiltersTypeGetParameters,
            GetFiltersNotificationTriggersFiltersTypeGetError
          >
        | QueryFiltersByQueryKey<
            GetFiltersNotificationTriggersFiltersTypeGetSchema,
            GetFiltersNotificationTriggersFiltersTypeGetData,
            TInfinite,
            GetFiltersNotificationTriggersFiltersTypeGetParameters,
            GetFiltersNotificationTriggersFiltersTypeGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /** @summary Get Filters */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetFiltersNotificationTriggersFiltersTypeGetSchema,
            GetFiltersNotificationTriggersFiltersTypeGetData,
            TInfinite,
            GetFiltersNotificationTriggersFiltersTypeGetParameters,
            GetFiltersNotificationTriggersFiltersTypeGetError
          >
        | QueryFiltersByQueryKey<
            GetFiltersNotificationTriggersFiltersTypeGetSchema,
            GetFiltersNotificationTriggersFiltersTypeGetData,
            TInfinite,
            GetFiltersNotificationTriggersFiltersTypeGetParameters,
            GetFiltersNotificationTriggersFiltersTypeGetError
          >
    ): number;
    schema: GetFiltersNotificationTriggersFiltersTypeGetSchema;
    types: {
      parameters: GetFiltersNotificationTriggersFiltersTypeGetParameters;
      data: GetFiltersNotificationTriggersFiltersTypeGetData;
      error: GetFiltersNotificationTriggersFiltersTypeGetError;
    };
  };
}
/**
 * @summary Get All
 * @description Get all notification triggers for the current office, including system triggers.
 */
export const getAllNotificationTriggersGet = {
  schema: {
    method: 'get',
    url: '/notification_triggers',
    security: ['HTTPBearer'],
  },
} as {
  schema: GetAllNotificationTriggersGetSchema;
  [QraftServiceOperationsToken]: NotificationTriggersService['getAllNotificationTriggersGet'];
};
/**
 * @summary Create
 * @description Create a new notification trigger.
 */
export const createNotificationTriggersPost = {
  schema: {
    method: 'post',
    url: '/notification_triggers',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: CreateNotificationTriggersPostSchema;
  [QraftServiceOperationsToken]: NotificationTriggersService['createNotificationTriggersPost'];
};
/**
 * @summary Get By Id
 * @description Get notification trigger by ID.
 */
export const getByIdNotificationTriggersTriggerIdGet = {
  schema: {
    method: 'get',
    url: '/notification_triggers/{trigger_id}',
    security: ['HTTPBearer'],
  },
} as {
  schema: GetByIdNotificationTriggersTriggerIdGetSchema;
  [QraftServiceOperationsToken]: NotificationTriggersService['getByIdNotificationTriggersTriggerIdGet'];
};
/**
 * @summary Update
 * @description Update an existing notification trigger.
 */
export const updateNotificationTriggersTriggerIdPut = {
  schema: {
    method: 'put',
    url: '/notification_triggers/{trigger_id}',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: UpdateNotificationTriggersTriggerIdPutSchema;
  [QraftServiceOperationsToken]: NotificationTriggersService['updateNotificationTriggersTriggerIdPut'];
};
/**
 * @summary Delete
 * @description Delete a notification trigger.
 */
export const deleteNotificationTriggersTriggerIdDelete = {
  schema: {
    method: 'delete',
    url: '/notification_triggers/{trigger_id}',
    security: ['HTTPBearer'],
  },
} as {
  schema: DeleteNotificationTriggersTriggerIdDeleteSchema;
  [QraftServiceOperationsToken]: NotificationTriggersService['deleteNotificationTriggersTriggerIdDelete'];
};
/** @summary Get Filters */
export const getFiltersNotificationTriggersFiltersTypeGet = {
  schema: {
    method: 'get',
    url: '/notification_triggers/filters/{type}',
  },
} as {
  schema: GetFiltersNotificationTriggersFiltersTypeGetSchema;
  [QraftServiceOperationsToken]: NotificationTriggersService['getFiltersNotificationTriggersFiltersTypeGet'];
};
export const notificationTriggersService = {
  getAllNotificationTriggersGet,
  createNotificationTriggersPost,
  getByIdNotificationTriggersTriggerIdGet,
  updateNotificationTriggersTriggerIdPut,
  deleteNotificationTriggersTriggerIdDelete,
  getFiltersNotificationTriggersFiltersTypeGet,
} as const;
type GetAllNotificationTriggersGetSchema = {
  method: 'get';
  url: '/notification_triggers';
  security: ['HTTPBearer'];
};
type GetAllNotificationTriggersGetParameters = paths['/notification_triggers']['get']['parameters'];
type GetAllNotificationTriggersGetData =
  paths['/notification_triggers']['get']['responses']['200']['content']['application/json'];
type GetAllNotificationTriggersGetError =
  paths['/notification_triggers']['get']['responses']['422']['content']['application/json'];
type CreateNotificationTriggersPostSchema = {
  method: 'post';
  url: '/notification_triggers';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type CreateNotificationTriggersPostParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type CreateNotificationTriggersPostData =
  paths['/notification_triggers']['post']['responses']['200']['content']['application/json'];
type CreateNotificationTriggersPostError =
  paths['/notification_triggers']['post']['responses']['422']['content']['application/json'];
type CreateNotificationTriggersPostBody =
  paths['/notification_triggers']['post']['requestBody']['content']['application/json'];
type GetByIdNotificationTriggersTriggerIdGetSchema = {
  method: 'get';
  url: '/notification_triggers/{trigger_id}';
  security: ['HTTPBearer'];
};
type GetByIdNotificationTriggersTriggerIdGetParameters =
  paths['/notification_triggers/{trigger_id}']['get']['parameters'];
type GetByIdNotificationTriggersTriggerIdGetData =
  paths['/notification_triggers/{trigger_id}']['get']['responses']['200']['content']['application/json'];
type GetByIdNotificationTriggersTriggerIdGetError =
  paths['/notification_triggers/{trigger_id}']['get']['responses']['422']['content']['application/json'];
type UpdateNotificationTriggersTriggerIdPutSchema = {
  method: 'put';
  url: '/notification_triggers/{trigger_id}';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type UpdateNotificationTriggersTriggerIdPutParameters =
  paths['/notification_triggers/{trigger_id}']['put']['parameters'];
type UpdateNotificationTriggersTriggerIdPutData =
  paths['/notification_triggers/{trigger_id}']['put']['responses']['200']['content']['application/json'];
type UpdateNotificationTriggersTriggerIdPutError =
  paths['/notification_triggers/{trigger_id}']['put']['responses']['422']['content']['application/json'];
type UpdateNotificationTriggersTriggerIdPutBody =
  paths['/notification_triggers/{trigger_id}']['put']['requestBody']['content']['application/json'];
type DeleteNotificationTriggersTriggerIdDeleteSchema = {
  method: 'delete';
  url: '/notification_triggers/{trigger_id}';
  security: ['HTTPBearer'];
};
type DeleteNotificationTriggersTriggerIdDeleteParameters =
  paths['/notification_triggers/{trigger_id}']['delete']['parameters'];
type DeleteNotificationTriggersTriggerIdDeleteData =
  paths['/notification_triggers/{trigger_id}']['delete']['responses']['200']['content']['application/json'];
type DeleteNotificationTriggersTriggerIdDeleteError =
  paths['/notification_triggers/{trigger_id}']['delete']['responses']['422']['content']['application/json'];
type DeleteNotificationTriggersTriggerIdDeleteBody = undefined;
type GetFiltersNotificationTriggersFiltersTypeGetSchema = {
  method: 'get';
  url: '/notification_triggers/filters/{type}';
};
type GetFiltersNotificationTriggersFiltersTypeGetParameters =
  paths['/notification_triggers/filters/{type}']['get']['parameters'];
type GetFiltersNotificationTriggersFiltersTypeGetData =
  paths['/notification_triggers/filters/{type}']['get']['responses']['200']['content']['application/json'];
type GetFiltersNotificationTriggersFiltersTypeGetError =
  paths['/notification_triggers/filters/{type}']['get']['responses']['422']['content']['application/json'];
